import React, { useState } from "react";
import { FiChevronDown, FiUser, FiLogOut, FiSettings } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import NotificationBell from "./NotificationBell";
import axios from "axios";
 
import "./layout.css";
 
const Navbar = ({ toggleSidebar }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const navigate = useNavigate();
 
  const handleLogout = async () => {
    try {
      const res = await axios.post(
        "https://irc.zentelex.com/api/app-user-auth/logout",
        {},
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        },
      );
 
      alert(res.data.message || "Logged out successfully");
 
      if (res.data.success) {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("user");
        navigate("/login");
      }
    } catch (err) {
      alert(err.response?.data?.message || "Logout failed");
    }
  };
 
  const toggleDropdown = () => setShowDropdown((prev) => !prev);
  const closeDropdown = () => setShowDropdown(false);
 
  return (
    <nav className="navbar navbar-glass shadow-sm py-2">
      <div className="container-fluid px-4 navbar-wrapper d-flex align-items-center">
        {/* LEFT — LOGO */}
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img src="/irc-logo.png" alt="IRC Logo" width="42" height="42" />
        </Link>
 
        {/* Sidebar Toggle */}
 
        {/* RIGHT SIDE */}
        <div className="ms-auto d-flex align-items-center gap-3">
          <button
            className="sidebar-toggle-btn ms-3 d-lg-none"
            onClick={toggleSidebar}
            type="button"
          >
            ☰ <span className="btn-text">Menu</span>
          </button>
          {/* Notifications */}
          <NotificationBell />
 
          {/* Profile Dropdown */}
          <div className="dropdown position-relative">
            <button
              className="nav-link d-flex align-items-center gap-2 px-3 py-2 rounded-pill profile-trigger border-0 bg-transparent"
              onClick={toggleDropdown}
              type="button"
            >
              <div className="avatar-circle">
                {user?.name?.charAt(0)?.toUpperCase() || "T"}
              </div>
 
              <span className="d-none d-lg-inline fw-semibold">
                {user?.name || "Test"}
              </span>
 
              <FiChevronDown
                size={14}
                className={`transition ${showDropdown ? "rotate-180" : ""}`}
              />
            </button>
 
            {/* Dropdown Menu */}
            {showDropdown && (
              <div
                className="dropdown-menu dropdown-menu-end shadow border-0 rounded-4 mt-2 py-2 show"
                style={{
                  display: "block",
                  minWidth: "220px",
                  right: 0,
                }}
                onClick={closeDropdown} // close when clicking inside
              >
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to="/profile"
                >
                  <FiUser size={18} /> Profile
                </Link>
 
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to="/settings"
                >
                  <FiSettings size={18} /> Settings
                </Link>
 
                <hr className="my-1 mx-2" />
 
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to="/superadmin/masterclientlist"
                >
                  📦 Order Processing
                </Link>
 
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to="/superadmin/deliveryorderlist"
                >
                  🚚 Delivery Orders
                </Link>
 
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to="/superadmin/create-admin"
                >
                  👤 Create Admin
                </Link>
 
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to="/admin/createuser"
                >
                  ➕ Create User
                </Link>
 
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to="/superadmin/deletedata"
                >
                  🗑 Delete Data
                </Link>

		 <Link
                   className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to="/superadmin/updatedata"
                     >
                   ✏️ Update Data
                 </Link>
                <hr className="my-1 mx-2" />
 
                <button
                  className="dropdown-item d-flex align-items-center gap-2 text-danger fw-semibold py-2"
                  onClick={handleLogout}
                  type="button"
                >
                  <FiLogOut size={18} /> Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};
 
export default Navbar;
